import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { usePriceFreezeMultiOfferQuery } from '@/hooks/GQL';
import { OfferTypes } from '@/constants/offerTypes';

const PriceFreezeMultiOfferContext = createContext({});

export function PriceFreezeMultiOfferProvider({
  searchId,
  fareItineraryKey,
  segmentKeys,
  children,
}) {
  const { data, errors, loading } = usePriceFreezeMultiOfferQuery({
    searchId,
    fareItineraryKey,
    segmentKeys,
  });

  return (
    <PriceFreezeMultiOfferContext.Provider value={{ data, errors, loading }}>
      {children}
    </PriceFreezeMultiOfferContext.Provider>
  );
}

PriceFreezeMultiOfferProvider.propTypes = {
  searchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  fareItineraryKey: PropTypes.string.isRequired,
  segmentKeys: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export function usePriceFreezeMultiOffers() {
  return (
    useContext(PriceFreezeMultiOfferContext).data?.itineraryPriceFreezeOffers ||
    []
  );
}

export function useIsMultiOfferLoading() {
  return useContext(PriceFreezeMultiOfferContext)?.loading;
}

export function usePriceFreezePrimeOffer() {
  return useOfferByType(OfferTypes.PRIME);
}

export function usePriceFreezeNonPrimeOffer() {
  return useOfferByType(OfferTypes.NON_PRIME);
}

function useOfferByType(offerType) {
  return usePriceFreezeMultiOffers().find(
    (priceFreezeOffer) => priceFreezeOffer?.offer?.offerType === offerType
  );
}
